module.exports = __webpack_public_path__ + "img/kakao.faeb7986.svg";